
import React, { useState, useEffect } from "react";
import { Box, Button, Grid, makeStyles, Typography, TextField } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import editorConfiguration from "../../../../util/EditorConfiguration";
import { useLoading } from "../../../../util/LoadingProvider";
import {
    InputAdornment,
  } from "@material-ui/core";

const defaultFormValues = {
    emailAddressSender: "",
    termsAndConditionsEn: "",
    termsAndConditionsTc: "",
};

const useStyles = makeStyles((theme) => ({
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "362px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
    },
}));

export default function EShopSettingPage({ disabled, ...props }) {
    const [defaultValues] = useState(defaultFormValues);
    const [initialValues, setInitialValues] = useState({});
    const { setLoading } = useLoading();

    const classes = useStyles();

    const {
        control,
        handleSubmit,
        setValue,
    } = useForm({
        defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    });

    const onSubmit = (value) => {
        updateEshopSetting(value);
    };

    const getEshopSetting = async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getEshopSetting();
            console.log(result);
            setInitialValues(result.data);
            setValue("emailAddressSender", result.data.emailAddressSender);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const updateEshopSetting = async (value) => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.updateEshopSetting(value);
            console.log(result);
            if (result.status === 200) {
                toast.dark("Your changes are saved.");
                await getEshopSetting();
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getEshopSetting();
    }, []);

    return (
        <div className={classes.content}>
            <Box width="100%">
                <Typography variant="h4" gutterBottom>
                    eShop > Setting
        </Typography>
            </Box>
            {initialValues ? (
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                control={control}
                                name="emailAddressSender"
                                defaultValue=""
                                render={({ field }) => {
                                    return (
                                        <TextField
                                            id="outlined-basic"
                                            className={classes.root}
                                            label="Email Address Sender"
                                            variant="outlined"
                                            helperText="The name is how it shows in your email sender name."
                                            {...field}
                                            fullWidth
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">@hkiff.org.hk</InputAdornment>,
                                            }}
                                        />
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Box fontWeight={900} fontSize={13} mb={2} width="100%">
                        <Typography variant="p">Payment Terms & Conditions (English)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            name="termsAndConditionsEn"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        editor.setData(initialValues.termsAndConditionsEn);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Box fontWeight={900} fontSize={13} mt={4} mb={2} width="100%">
                        <Typography variant="p">Payment Terms & Conditions (Traditional Chinese)</Typography>
                    </Box>

                    <Grid item xs={12}>
                        <Controller
                            name="termsAndConditionsTc"
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <CKEditor
                                    editor={Editor}
                                    config={editorConfiguration}
                                    data={field.value}
                                    disabled={disabled}
                                    onReady={(editor) => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log("Editor is ready to use!", editor);
                                        editor.setData(initialValues.termsAndConditionsTc);
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                        // console.log({ event, editor, data });
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    {disabled || (
                        <div className={classes.buttonGroup}>
                            <Button
                                type="submit"
                                variant="contained"
                                disableElevation
                                style={{
                                    color: "white",
                                    background: "#306F9D",
                                    marginRight: "5px",
                                    padding: "9px 16px",
                                }}
                            >
                                Save
              </Button>
                        </div>
                    )}
                </form>
            ) : (
                    <></>
                )
            }
        </div >
    );
}
